export default __webpack_public_path__ + "static/media/hideMenuIcon.e0989da7.svg";